type CubeSvgProps = {
  className?: string;
};

export const CubeSvg = ({ className }: CubeSvgProps) => {
  return (
    <svg
      width="55"
      height="61"
      viewBox="0 0 55 61"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M1 12.9578L27.544 1.00049L53.9838 12.9578L52.8388 45.3065L27.544 60.0396L2.14503 45.3065L1 12.9578Z"
        stroke="black"
        stroke-width="1.25141"
      />
      <path
        d="M1.14844 12.9575L27.6924 1.00024L54.1323 12.9575M1.14844 12.9575L2.29347 45.3063L27.6924 60.0394M1.14844 12.9575L27.6924 26.5162M27.6924 60.0394L52.9872 45.3063L54.1323 12.9575M27.6924 60.0394V26.5162M54.1323 12.9575L27.6924 26.5162"
        stroke="black"
        stroke-opacity="0.2"
        stroke-width="1.25141"
      />
    </svg>
  );
};
